export default __webpack_public_path__ + "static/frame-008-87103b6adc5170bdf457c529a4e902ae.png";